import { ResetRoutes } from 'router'
import React from 'react'


const ResetPassword = () => {

    return (
        <ResetRoutes />
    )
}

export default ResetPassword